import { MarketplaceItemsWrapper } from '../../components'

export default function MarketplaceItemsPage() {
  return <MarketplaceItemsWrapper />
}
